import React from "react";
import { useLanguage } from "../../Translations/LenguageContext";

const NoFilesFound = () => {
    const {t} = useLanguage()
    return(
        <div className="no_org_cont">
            <p>{t.cloud.no_files_found}</p>
        </div>
    )
}


export default NoFilesFound